module.exports = __webpack_public_path__ + "static/media/10.c77784c6.svg";